import moment from 'moment'
import { languages } from '@/types/languages'
import { i18n } from '@/plugins/i18n'

export function localMoments() {
    let lang = languages.find((item) => item['639-2'] == i18n.locale)?.['639-1']

    if (lang?.includes('no')) {
        lang = 'nb'
    }

    return lang ? lang : 'nb'
}

export function timeFrom(start: any, end: any, type?: boolean) {
    moment.locale(localMoments())
    return moment(start).from(moment(end), type)
}
